/**
 * Patient create/edit/view share this hide list so the create form
 * (including QuickPatientSelect) matches /patients/:id.
 */
export const PATIENT_FIELDS_TO_HIDE = [
  'Id',
  'FullName',
  'StudyHash',
  'StatusReason',
  'BatchName',
  'CreatedAt',
  'UpdatedAt',
  'CreatedBy',
  'UpdatedBy',
  'UploadBatchIds',
  'ProcessingStatus',
  'ProcessedAt',
  'DateOfDeath',
  'Ethnicity',
  'Address',
];

export function isPatientFormField(fieldName) {
  const hide = new Set(PATIENT_FIELDS_TO_HIDE.map((n) => n.toLowerCase()));
  return !hide.has(String(fieldName || '').toLowerCase());
}
